import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import React, {useState, useEffect} from 'react';
import axios from 'api/axios';
import { Spinner } from 'react-bootstrap';

import DefaultCard from 'components/mycomponents/DefaultCard';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);

const getOptions = data => ({
  tooltip: {
    trigger: 'axis',
    padding: [7, 10],
    axisPointer: {
      type: 'none'
    },
    backgroundColor: getColor('gray-100'),
    borderColor: getColor('gray-300'),
    textStyle: { color: getColor('dark') },
    borderWidth: 1,
    transitionDuration: 0
  },
  xAxis: {
    type: 'category',
    data: data[0],
    axisLabel: {
      color: getColor('gray-600'),
      formatter: value => value.substring(0, 6)
    },
    axisLine: {
      lineStyle: {
        color: getColor('gray-400')
      }
    },
    axisTick: {
      show: true,
      alignWithLabel: true,
      lineStyle: {
        color: getColor('gray-200')
      }
    }
  },
  yAxis: {
    type: 'value',
    axisTick: {
      show: false
    },
    splitLine: {
      lineStyle: {
        color: getColor('gray-300'),
        type: 'dashed'
      }
    },
    axisLabel: {
      color: getColor('gray-600'),
      formatter: value => `${value}`,
      fontWeight: 500,
      padding: [3, 0, 0, 0],
      margin: 12
    },
    axisLine: {
      show: false
    }
  },
  series: [
    {
      type: 'bar',
      data: data[1],
      itemStyle: {
        borderRadius: [3, 3, 0, 0],
        color: getColor('primary')
      },
      barWidth: 15
    }
  ],
  grid: {
    containLabel: true,
    right: 0,
    left: 0,
    bottom: 0,
    top: 15
  }
});

const WeeklyReport = () => {
  // Declare State Variable
    const [data, setData] = useState([[],[]]);
    const [loadingData, setLoadingData] = useState(false);
    
    // Declare Constant Variable
    const DATA_URL = '/dashboard/';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    
    useEffect(() => {
        const getVehicleActivity = async () =>{
            setLoadingData(true);
            try {
                const response = await axios.get(`${DATA_URL}weekly-data`, {
                  headers: {
                    'Authorization': `Bearer ${TOKEN_APP}`
                  }
                });
                const responseResult = response?.data;
                const responseData = responseResult?.data;
                let valueData = [];
                let nameData = [];

                if (responseData) {
                  responseData.forEach(data => {
                    valueData.push(data.total)
                    nameData.push(data.vcnama)
                  });
                }

                const dataChart = [nameData, valueData]
                setData(dataChart);

                setLoadingData(false);
                
            } catch (err) {
                setLoadingData(false);
                if (err.response) {
                    const response = err.response.data;
                    console.log(response.message);
                } else {
                    console.log('Something error with server. Please call administrator or developer.');
                }
            }
        }

        getVehicleActivity()
    }, [TOKEN_APP]);

    return (
        <DefaultCard>
            <DefaultCard.Header title={'Laporan Per Minggu'} />
            <DefaultCard.Body>
              {
                  loadingData ? (<>
                    <Spinner animation="border  " className="me-2" />
                    <span className="fs-4">Loading ...</span>
                  </>) :
                  (
                    <ReactEChartsCore
                      echarts={echarts}
                      option={getOptions(data)}
                      style={{ height: '13.125rem' }}
                    />
                  )
              }
            </DefaultCard.Body>
        </DefaultCard>
    )
}

WeeklyReport.propTypes = {}

export default WeeklyReport;